import React from "react";
import { Outlet } from "react-router-dom";

const LayoutIngresos = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default LayoutIngresos;
